import React,{Component} from 'react';
import {AuthRoute} from '../AuthRoute';
import Header from './header/Header';
import Dashboard from './content/dashboard/Dashboard';
import Account from './content/account/Account';
import DocketPage from './content/findCase/DocketPage';
import DocketGeneralInfo from './content/docketGeneralInfo/DocketGeneralInfo';
import DocumentActivity from './content/documentActivity/DocumentActivity';
import { connect } from 'react-redux';
import LoginSessionExpired from '../ui/LoginSessionExpired';



class publicAccessContainer extends Component {
	componentDidMount(){
	}
	render(){
		return (
			<div>
				<Header/>
				<div className="content" role="main">
					<AuthRoute exact path={`${this.props.match.path}/docketAccess/:eCourtUserId?/:tablename?`} component={DocketPage} />
					<AuthRoute exact path={`${this.props.match.path}/dashboard/:status?`} component={Dashboard} />
					<AuthRoute path={`${this.props.match.path}/docketInfo/:docketno`}component={DocketGeneralInfo} />
					<AuthRoute path={`${this.props.match.path}/documentActivity`}component={DocumentActivity} />
					<AuthRoute exact path={`${this.props.match.path}/account`} component={Account} />
					
				</div>
				<LoginSessionExpired/>
			</div>
		)
	}
}
export default connect(null)(publicAccessContainer);